import React from "../_snowpack/pkg/react.js";
import {Layout} from "./Layout.js";
export const App = () => {
  return /* @__PURE__ */ React.createElement(Layout, null);
};
